import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import metmask from "../../assets/icons/wallets/metamask.svg";
import coinbase from "../../assets/icons/wallets/walletlink.svg";
import walletConnect from "../../assets/icons/wallets/walletconnect.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";

//reducer
import { initWalletConnect } from "../../redux/walletReducer";
import { AnyAction } from "@reduxjs/toolkit";
import { MOBILE } from "../../constants/breakpoints";
import { WarningText } from "../../shared/typography";

const WalletProvider = ({
  icon,
  name,
  defaultWallet,
}: {
  icon: string;
  name: string;
  defaultWallet?: boolean;
}) => {
  return (
    <div
      css={css`
        display: flex;
        border: 1px solid #757272;
        background: #ffffff;
        width: 363px;
        height: 80px;
        border-radius: 10px;
        padding: 26px 24px;
        align-items: center;
        cursor: pointer;

        @media (max-width: ${MOBILE}px) {
          width: 100%;
        }
      `}
    >
      <img
        css={css`
          width: 33px;
          object-fit: contain;
          margin-right: 15px;
        `}
        src={icon}
        alt={name}
      />
      <h3>{name}</h3>
      {defaultWallet && (
        <p
          css={css`
            margin-left: auto;
            font-weight: 500;
            font-size: 16px;
            text-align: right;
            color: #a29b8b;

            @media (max-width: ${MOBILE}px) {
              font-weight: 700;
              font-size: 14px;
            }
          `}
        >
          Default
        </p>
      )}
    </div>
  );
};

const WalletList = ({ switchToInfo }: { switchToInfo?: () => void }) => {
  let wallet = useSelector((state: RootState) => state.walletState);
  let dispatch = useDispatch();
  return (
    <span
      css={css`
        display: flex;
        height: 100%;
        width: 100%;
        flex-direction: column;
      `}
    >
      {
        window?.ethereum && typeof window.ethereum !== "undefined"
        ? <></>
        : <WarningText>Please Install Metamask</WarningText>
      }
      <span
        onClick={() => {
          dispatch(initWalletConnect() as any as AnyAction);
        }}
        css={css`
          pointer-events: ${window?.ethereum && typeof window.ethereum !== "undefined" ? 'unset' : 'none'};
          opacity: ${window?.ethereum && typeof window.ethereum !== "undefined" ? '1' : '.5'};
        `}
      >
        <WalletProvider icon={metmask} name={"Metamask"} defaultWallet={true} />
      </span>

      <div
        css={css`
          display: flex;
          height: max-content;
          flex-direction: column;
          gap: 8px;
          margin-top: auto;
          opacity: 0.5;

          @media (max-width: ${MOBILE}px) {
            margin-top: 0;
          }
        `}
      >
        <h2
          css={css`
            font-weight: 500;
            font-size: 16px;
          `}
        >
          Coming Soon
        </h2>
        <WalletProvider icon={walletConnect} name={"Wallet Connect"} />
        <WalletProvider icon={coinbase} name={"Coinbase"} />
        <WalletProvider icon={metmask} name={"Fortmatic"} />
      </div>
      <h3
        css={css`
          margin: 0 auto;
          margin-top: auto;
          text-decoration: underline;
          display: none;
          cursor: pointer;
          @media (max-width: ${MOBILE}px) {
            display: block;
          }
        `}
        onClick={() => {
          switchToInfo && switchToInfo();
        }}
      >
        What is a Wallet?
      </h3>
    </span>
  );
};

export default WalletList;
